import BaseView from "./BaseView";

export default BaseView;
